import { defineStore } from "pinia";
// import { useApi as useGqlApi } from "@js/api/gql";
import { useApi } from "@js/api";
import { ref, type Ref } from "vue";
// import { createMediaFiltersQuery } from "../queries";
// import { formatFilters } from "@/js/helpers/filters";
// const initialFilters = {
//   productStyle: null,
//   productType: null,
//   productModel: null,
//   buildingType: null,
// }

export const useFiltersStore = defineStore("filters", () => {
  const searchQuery: Ref<string | null> = ref(null);
  // const imageType = ref(null);
  // const filterData: Ref<ImageFilterData | null> = ref(null);
  // const filters = ref({ ...initialFilters });

  const folders: Ref<FilterOption[]> = ref([]);
  const folder: Ref<FilterOption | null> = ref(null);
  const folderList = useApi(
    () => ({ url: 'mediabank/volume-folders' }),
    (r: any) => r.data,
  );

  // const filterList = useGqlApi(
  //   (query: string, variables: any) => ({
  //     query,
  //     variables,
  //   }),
  //   (r: any) => r.data.data,
  // );

  async function getFilters() {
    // const queryFilters = formatFilters(unref(filters));
    // const data: unknown = await filterList.execute(createMediaFiltersQuery());
    folders.value = await folderList.execute();

    // filterData.value = data as ImageFilterData;
  }

  // const showSecondaryFilters = computed(() => {
  //   if (filterData.value === null) {
  //     return false;
  //   }
  //   const currentFilter = filterData.value.imageTypes.find((i: FilterOption) => i.id === imageType.value)
  //   if (!currentFilter) {
  //     return false;
  //   }
  //   return currentFilter.showSecondaryFilters
  // });


  return {
    searchQuery,
    folder,
    folders,
    isLoading: folderList.isLoading,
    error: folderList.error,
    getFilters,
    // imageType,
    // filters,
    // filterData,
    // showSecondaryFilters,
    // isLoading: filterList.isLoading,
    // error: filterList.error,
  };
});

